import React from 'react';
import {KTMScreen,ActionEvent,RenderEvent,renderScreen} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {Layout,Dialog,Button,Column,Panel,Display,Line,Card} from 'ktm-ui';

interface IdsPolicy {
    Id:string;
    PolicyNo:string;
    PolicyHolder_Id:string;
};

interface IdsPolicyHolder {
    Id:string;
    Name:string;
    MailingCity:string;
    MailingProv:string;
};

export default KTMScreen({name:"planadmin.policy.change-policy-holder"}, class extends React.Component<{policy_id:string}> {

    data:{
        dsPolicy:IdsPolicy;
        dsPolicyHolder:IdsPolicyHolder;
    }

    render(){
        return renderScreen(this);
    }

    async start({screen}:ActionEvent){
        screen.defaultRecord = "@dsPolicy";
        await KTMApi.start(screen,{
            "@policy_id":this.props.policy_id,
        });
        screen.title = "Change account holder";
    }

    main({field,draw,action}:RenderEvent){
        return (
            <Layout>
                {draw(this.header)}
                {draw(this.main_tab)}
                {draw(this.footer)}
            </Layout>
        );
    }

    header({field,draw,action}:RenderEvent){
        return (
            <Dialog.Header label="Change account holder"/>
        );
    }

    footer({field,draw,action}:RenderEvent){
        return (
            <Dialog.Footer>
                <Button action={action(this.submit)} label="Save" size="large" style="primary"/>
            </Dialog.Footer>
        );
    }

    main_tab({field,draw,action}:RenderEvent){
        return (
            <Panel>
                <Column>
                    {draw(this.details)}
                </Column>
                <Column>
                </Column>
            </Panel>
        );
    }

    details({field,draw,action}:RenderEvent){
        return (
            <Card>
                <Display field={field("PolicyHolder_Id")}/>
                <Line>
                    <Display field={field("@dsPolicyHolder.MailingCity")}/>
                    <Display field={field("@dsPolicyHolder.MailingProv")}/>
                </Line>
            </Card>
        );
    }

    async submit({screen}:ActionEvent){
        await KTMApi.action(screen,"submit",{
            "@dsPolicy.PolicyHolder_Id":this.data.dsPolicy.PolicyHolder_Id,
            "@policy_id":this.props.policy_id,
        });
        screen.close({"continue":true});
    }

});
